import { FC, useId, useState } from 'react';
import { clsx } from 'clsx';
import type { TenderLevel } from './tenderStatusModel';

/**
 * «Ход закупки»: уровни с точкой-маркером; по клику уровень раскрывается в список подэтапов. По умолчанию раскрыт
 * текущий уровень (фронт или ветки, которые держат закупку).
 */
const TenderRoute: FC<{ levels: TenderLevel[] }> = ({ levels }) => {
    const id = useId();
    const [toggled, setToggled] = useState<Record<number, boolean>>({});

    return (
        <ol className="tender-status__levels">
            {levels.map((level, li) => {
                const open = toggled[li] ?? level.state === 'now';
                const stepsId = `${id}-${li}`;
                return (
                    <li
                        key={`${li}:${level.title}`}
                        className={clsx('tender-status__level', `tender-status__level--${level.state}`)}
                        data-testid="tender-status-level"
                        data-state={level.state}
                    >
                        <button
                            type="button"
                            className="tender-status__level-btn"
                            aria-expanded={open}
                            aria-controls={stepsId}
                            onClick={() => setToggled((prev) => ({ ...prev, [li]: !open }))}
                        >
                            <span
                                className={clsx(
                                    'tender-status__dot',
                                    `tender-status__dot--${level.state}`,
                                    level.tone && `tender-status__dot--${level.tone}`,
                                )}
                                aria-hidden
                            />
                            <span className="tender-status__level-text">
                                <span className="tender-status__level-name">{level.title}</span>
                                <span className="tender-status__level-meta">{level.meta}</span>
                            </span>
                        </button>
                        <div
                            id={stepsId}
                            className="tender-status__steps"
                            data-open={open || undefined}
                            aria-hidden={!open}
                            inert={!open}
                        >
                            <ul>
                                {level.steps.map((step, si) => (
                                    <li
                                        key={`${si}:${step.title}`}
                                        className={clsx(
                                            'tender-status__step',
                                            `tender-status__step--${step.state}`,
                                            step.tone && `tender-status__step--${step.tone}`,
                                        )}
                                        data-testid="tender-status-step"
                                        data-state={step.state}
                                    >
                                        <span>{step.title}</span>
                                        {step.note && <small>{step.note}</small>}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </li>
                );
            })}
        </ol>
    );
};

export default TenderRoute;
